"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = StoredPaymentMethod;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _reactNative = require("react-native");
var _styles = require("@sart/styles");
var _icons = require("@sart/icons");
var _content = require("@sart/content");
var _client = require("@sart/client");
var _Text = _interopRequireDefault(require("./Text"));
var _Label = _interopRequireDefault(require("./Label"));
var _Space = _interopRequireDefault(require("./Space"));
var _Anchor = _interopRequireDefault(require("./Anchor"));
var _excluded = ["editable", "disabled", "onEditPayment", "title", "style", "footerStyle", "containerStyle", "cardTypeColor", "chevronRight", "chevronColor", "noMethodSelectedText", "displayTextChange", "displayTextChoose"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function StoredPaymentMethod(props) {
  var content = (0, _content.useContent)();
  var _useClient = (0, _client.useClient)(),
    _useClient$cache = _useClient.cache,
    _useClient$cache2 = _useClient$cache === void 0 ? {} : _useClient$cache,
    storedPayment = _useClient$cache2.storedPayment;
  var editable = props.editable,
    disabled = props.disabled,
    onEditPayment = props.onEditPayment,
    title = props.title,
    style = props.style,
    footerStyle = props.footerStyle,
    containerStyle = props.containerStyle,
    cardTypeColor = props.cardTypeColor,
    chevronRight = props.chevronRight,
    chevronColor = props.chevronColor,
    noMethodSelectedText = props.noMethodSelectedText,
    displayTextChange = props.displayTextChange,
    displayTextChoose = props.displayTextChoose,
    rest = (0, _objectWithoutProperties2["default"])(props, _excluded);
  var _props$payment = props.payment,
    payment = _props$payment === void 0 ? storedPayment : _props$payment;
  //set the card type if we have a tokenized card.
  if (payment && payment.tokenizedCards) {
    payment.type = payment.tokenizedCards[0].cardType;
  }
  if (payment !== undefined && payment.preview === undefined && payment.tokenizedCards) {
    payment.preview = "************" + payment.tokenizedCards[0].last4Digits;
  } else if (payment === undefined) {
    payment = {
      preview: noMethodSelectedText || content.checkout.preview
    };
  }
  return /*#__PURE__*/_react["default"].createElement(_reactNative.View, (0, _extends2["default"])({
    style: styles.container
  }, rest), title && /*#__PURE__*/_react["default"].createElement(_Label["default"], {
    style: style
  }, title), /*#__PURE__*/_react["default"].createElement(_Space["default"], {
    height: 8
  }), /*#__PURE__*/_react["default"].createElement(_reactNative.TouchableOpacity, {
    style: [styles.wrapper, containerStyle],
    disabled: disabled || !editable,
    onPress: onEditPayment
  }, /*#__PURE__*/_react["default"].createElement(_icons.CreditCartType, {
    color: cardTypeColor,
    type: payment.type
  }), /*#__PURE__*/_react["default"].createElement(_Space["default"], {
    width: 12,
    height: 24
  }), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    style: [style, disabled && styles.previewDisabled]
  }, payment.preview), chevronRight && /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: {
      alignItems: 'flex-end',
      flex: 1
    }
  }, /*#__PURE__*/_react["default"].createElement(_icons.ChevronRight, {
    color: chevronColor
  }))), editable && /*#__PURE__*/_react["default"].createElement(_Anchor["default"], (0, _extends2["default"])({
    style: footerStyle,
    title: payment && payment.type ? displayTextChange || content.common.change : displayTextChoose || content.common.choose,
    onPress: onEditPayment,
    disabled: disabled
  }, style && style.storedPaymentChoose && {
    style: style.storedPaymentChoose
  })));
}
var styles = _reactNative.StyleSheet.create({
  container: {
    // paddingVertical: 8
  },
  wrapper: _objectSpread(_objectSpread({
    flexDirection: 'row',
    alignItems: 'center',
    padding: 12
  }, _reactNative.Platform.select({
    web: {
      padding: 8
    }
  })), {}, {
    borderRadius: _styles.radius.smedium,
    backgroundColor: _styles.backgroundColors.subtle
  }),
  preview: _objectSpread({
    fontSize: 18
  }, _reactNative.Platform.select({
    web: {
      fontSize: 15
    }
  })),
  previewDisabled: {
    color: _styles.colors.trivial
  },
  choose: {
    fontSize: 15,
    color: _styles.colors.trivial,
    marginTop: 8
  }
});